(function () {
  var root = document.querySelector('.mr-root');
  if (!root) return;
  var cfg = root.dataset; var sid = cfg.sid;

  /* ---------- Slow scroll to top (all buttons) ---------- */
  var DURATION = +cfg.scroll || 1800;
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  var scrolling = false, cancelled = false;
  function slowTop() {
    if (scrolling) return;
    var start = window.pageYOffset || document.documentElement.scrollTop;
    if (start <= 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, 0); return; }
    scrolling = true; cancelled = false;
    var t0 = null;
    var prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    function done() { scrolling = false; document.documentElement.style.scrollBehavior = prev; }
    function step(ts) {
      if (cancelled) { done(); return; }
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / DURATION, 1);
      window.scrollTo(0, start * (1 - ease(p)));
      if (p < 1) { requestAnimationFrame(step); } else { done(); }
    }
    requestAnimationFrame(step);
  }
  root.querySelectorAll('[data-slow-top]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); slowTop(); }); });
  ['wheel', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, function () { if (scrolling) cancelled = true; }, { passive: true }); });

  /* ---------- Back-to-top + sticky bar visibility ---------- */
  var topBtn = root.querySelector('.mr-top');
  var sticky = document.getElementById('mr-sticky-' + sid);
  var buy = document.getElementById('mr-atc-' + sid);
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      topBtn.classList.toggle('show', window.pageYOffset > 700);
      if (sticky && buy) sticky.classList.toggle('show', buy.getBoundingClientRect().bottom < 0);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- Gallery ---------- */
  var mainImg = document.getElementById('mr-main-img-' + sid);
  var thumbs = root.querySelectorAll('.mr-thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) mainImg.src = t.dataset.src;
      thumbs.forEach(function (x) { x.classList.remove('on'); }); t.classList.add('on');
    });
  });

  /* ---------- Countdown clock: runs to the customer's own local midnight, then restarts ---------- */
  var cH = root.querySelector('[data-cd-h]'), cM = root.querySelector('[data-cd-m]'), cS = root.querySelector('[data-cd-s]');
  if (cH && cM && cS) {
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var diff = Math.max(0, midnight - now);
      cH.textContent = pad(Math.floor(diff / 36e5));
      cM.textContent = pad(Math.floor(diff % 36e5 / 6e4));
      cS.textContent = pad(Math.floor(diff % 6e4 / 1e3));
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Bundle + per-hood size picker ---------- */
  var pj = document.getElementById('mr-data-' + sid); var product = null; try { product = JSON.parse(pj.textContent); } catch (e) {}
  var variants = (product && product.variants) || [];
  var optNames = (product && product.options) || [];
  var form = document.getElementById('mr-form-' + sid);
  var msg = document.getElementById('mr-msg-' + sid);
  var holder = root.querySelector('.mr-items');
  var pickBox = root.querySelector('.mr-pick');
  var stockEl = root.querySelector('.mr-stock');
  var xw = root.querySelector('.mr-xp');
  var shipRow = root.querySelector('[data-sum-ship]');
  var single = variants.length <= 1;
  var items = [];
  var D = holder ? holder.dataset : {};
  var SIZES = { small: { inch: D.small, note: D.snote }, medium: { inch: D.medium, note: D.mnote }, large: { inch: D.large, note: D.lnote } };
  var fmt = function (c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cfg.currency }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  };
  function text(sel, v) { var n = root.querySelector(sel); if (n) n.textContent = v; }
  if (!variants.length && pickBox) pickBox.hidden = true;
  if (form && !form.querySelector('.mr-bundle input:checked')) { var f0 = form.querySelector('.mr-bundle input'); if (f0) f0.checked = true; }

  function firstOpts() { var v = variants.find(function (x) { return x.id === +cfg.variant; }) || variants[0]; return v ? v.options.slice() : []; }
  function vFor(sel) { return variants.find(function (v) { return sel.every(function (s, i) { return v.options[i] === s; }); }) || null; }
  function bundle() { return form.querySelector('.mr-bundle input:checked'); }
  function uniq(oi) { var out = []; variants.forEach(function (v) { if (out.indexOf(v.options[oi]) < 0) out.push(v.options[oi]); }); return out; }
  function sizeKey(val) {
    var s = String(val).trim().toLowerCase();
    if (s === 's' || s.indexOf('small') === 0) return 'small';
    if (s === 'm' || s.indexOf('medium') === 0) return 'medium';
    if (s === 'l' || s.indexOf('large') === 0) return 'large';
    return '';
  }
  function sizeInfo(val) { var k = sizeKey(val); return k ? SIZES[k] : null; }
  function bundleTotal(inp, qq, unitSub) {
    var fx = parseFloat(inp.dataset.price);
    if (!isNaN(fx) && fx > 0) return Math.round(fx * 100);
    return Math.round(unitSub * (100 - (+inp.dataset.pct)) / 100);
  }

  function buildItems() {
    if (!variants.length) return;
    var inp = bundle(); var q = inp ? +inp.dataset.qty : 1;
    while (items.length < q) items.push((items[0] || firstOpts()).slice());
    items.length = q;
    if (!holder) return;
    holder.innerHTML = '';
    if (single) return;
    items.forEach(function (sel, i) {
      var box = document.createElement('div'); box.className = 'mr-item';
      var t = document.createElement('div'); t.className = 'mr-item-t';
      t.appendChild(document.createTextNode('Hood ' + (i + 1) + ' · '));
      var tb = document.createElement('b'); tb.textContent = sel.join(' / '); t.appendChild(tb); box.appendChild(t);
      var capInfo = null;
      optNames.forEach(function (name, oi) {
        var g = document.createElement('div'); g.className = 'mr-og';
        if (optNames.length > 1) { var n = document.createElement('div'); n.className = 'mr-og-n'; n.textContent = name; g.appendChild(n); }
        var row = document.createElement('div'); row.className = 'mr-ochips';
        uniq(oi).forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'mr-ochip' + (sel[oi] === val ? ' on' : '');
          b.appendChild(document.createTextNode(val));
          var si = sizeInfo(val);
          if (si && si.inch) { var s = document.createElement('small'); s.textContent = si.inch + '"'; b.appendChild(s); }
          if (si && sel[oi] === val) capInfo = si;
          var test = sel.slice(); test[oi] = val; var vv = vFor(test); if (vv && vv.available === false) b.classList.add('out');
          b.addEventListener('click', function () {
            var next = sel.slice(); next[oi] = val;
            if (!vFor(next)) { var alt = variants.find(function (v) { return v.options[oi] === val; }); if (alt) next = alt.options.slice(); }
            items[i] = next; buildItems(); render();
          });
          row.appendChild(b);
        });
        g.appendChild(row); box.appendChild(g);
      });
      if (capInfo && capInfo.inch) {
        var cap = document.createElement('div'); cap.className = 'mr-cap';
        var cb = document.createElement('b'); cb.textContent = capInfo.inch + '"'; cap.appendChild(cb);
        if (capInfo.note) cap.appendChild(document.createTextNode(' · ' + capInfo.note));
        box.appendChild(cap);
      }
      holder.appendChild(box);
    });
  }

  function render() {
    if (!variants.length) return;
    var inp = bundle(); var q = +inp.dataset.qty;
    var first = vFor(items[0]) || variants[0];
    var maxSave = 0;
    form.querySelectorAll('.mr-bundle').forEach(function (lab) {
      var i2 = lab.querySelector('input'), qq = +i2.dataset.qty;
      var unit = first.price, was = (first.compare_at_price && first.compare_at_price > unit ? first.compare_at_price : unit) * qq;
      var total = bundleTotal(i2, qq, unit * qq);
      lab.querySelector('[data-total]').textContent = fmt(total);
      lab.querySelector('[data-was]').textContent = was > total ? fmt(was) : '';
      var save = was - total; lab.querySelector('[data-save]').textContent = save > 0 ? 'Save ' + fmt(save) : '';
      if (save > maxSave) maxSave = save;
    });
    var ms = root.querySelector('[data-maxsave]');
    if (ms) { ms.textContent = fmt(maxSave); var h = ms.closest('.mr-save-h'); if (h) h.style.display = maxSave > 0 ? '' : 'none'; }

    var value = 0, sub = 0, ok = true, soldOut = false;
    items.forEach(function (sel) {
      var v = vFor(sel); if (!v) { ok = false; return; }
      if (v.available === false) { ok = false; soldOut = true; }
      value += (v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price); sub += v.price;
    });
    var total = bundleTotal(inp, q, sub);
    text('[data-sum-name]', (product.title || 'T-Rex Skeleton Hood') + (q > 1 ? ' ×' + q : ''));
    text('[data-sum-value]', fmt(value));
    text('[data-sum-was]', value > total ? fmt(value) : '');
    text('[data-sum-total]', fmt(total));
    text('[data-sum-save]', value > total ? 'You save ' + fmt(value - total) + ' today' : '');
    text('[data-sticky-price]', fmt(total));
    if (shipRow) shipRow.hidden = q < 4;
    if (buy) {
      var lbl = buy.querySelector('[data-label]');
      buy.disabled = !ok;
      lbl.textContent = soldOut ? 'Sold out' : 'Add to Cart';
    }
    msg.textContent = soldOut ? 'One of those sizes is sold out — please pick another.' : '';

    /* Express checkout (Shop Pay / Apple Pay / PayPal) works when every hood is the same variant */
    if (xw) {
      var ids = items.map(function (sel) { var v = vFor(sel); return v ? v.id : null; });
      var same = ids.length > 0 && ids.every(function (x) { return x && x === ids[0]; });
      if (same) { xw.querySelector('[data-xid]').value = ids[0]; xw.querySelector('[data-xq]').value = q; }
      xw.querySelector('.mr-xp-btns').hidden = !(same && ok);
      xw.querySelector('.mr-xp-note').hidden = same || !ids.length;
    }

    if (first.featured_media && first.featured_media.id) {
      var th = root.querySelector('.mr-thumb[data-media="' + first.featured_media.id + '"]'); if (th && !th.classList.contains('on')) th.click();
    }
  }
  if (form) form.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.mr-bundle')) { buildItems(); render(); }
  });
  if (xw) {
    var xb = xw.querySelector('.mr-xp-btns');
    if (xb) xb.addEventListener('pointerdown', function () {
      var i = bundle(), c = i ? i.dataset.code : '';
      if (c) fetch('/discount/' + encodeURIComponent(c), { credentials: 'same-origin' }).catch(function () {});
    });
  }
  buildItems(); render();

  /* ---------- Real inventory only (no fake counters) ---------- */
  if (stockEl) {
    var stock = parseInt(stockEl.dataset.stock, 10), thr = parseInt(stockEl.dataset.threshold, 10);
    if (!isNaN(stock) && thr > 0 && stock > 0 && stock <= thr) {
      var sn = stockEl.querySelector('[data-stock-n]'); if (sn) sn.textContent = stock;
      stockEl.classList.add('show');
    }
  }

  /* ---------- Add to cart (+ optional bundle discount code) ---------- */
  if (buy) buy.addEventListener('click', function () {
    if (buy.disabled || !variants.length) return;
    var inp = bundle(), code = inp ? inp.dataset.code : '';
    var counts = {}; items.forEach(function (sel) { var v = vFor(sel); if (v) counts[v.id] = (counts[v.id] || 0) + 1; });
    var payload = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
    buy.disabled = true; msg.textContent = 'Summoning your dino…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: payload }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return code ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : null; })
      .then(function () { window.location.href = cfg.after === 'cart' ? '/cart' : '/checkout'; })
      .catch(function (r) {
        buy.disabled = false; msg.textContent = 'Could not add to cart. Please try again.';
        if (r && r.json) r.json().then(function (j) { if (j && j.description) msg.textContent = j.description; });
      });
  });
})();